import * as requestFromServer from "./BranchesCrud";
import { callTypes, branchSlice } from "./BranchesSlice";

const {actions} = branchSlice;

export const getBranches = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getBranches(queryParams)
    .then(response => {
      dispatch(actions.branchesFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllBranches = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllBranches(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getBranch = id => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  
  if (!id) {
    return requestFromServer
    .getNewBranch()
    .then(response => {
      dispatch(actions.branchFetched(response.data));
    })
    .catch(error => {
      
    });
  }
  
  return requestFromServer
    .getBranch(id)
    .then(response => {
      dispatch(actions.branchFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const saveBranch = branch => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveBranch(branch)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });    
};

export const deleteBranches = ids => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteBranches(ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const cleanBranchesState = () => dispatch => {
  dispatch(actions.branchesStateCleaned());
}